import Visualization from "./visualization";
import Form from "../../../formability/form_builder/models/form"
import ObjectModel from "~/models/objectModel"
import {ModelType} from "~/enums/modelType"

export const loadRelatedDocuments = (visualization: Visualization) => {
  const loadForm = (formJson) => {
    Form.repo.findOrCreate(formJson.id, formJson.client_id).loadFromJson(formJson);
  };
  const loadObjectModel = (objectModelJson) => {
    ObjectModel.repo.findOrCreate(objectModelJson.client_id).loadFromJson(objectModelJson);
  };
  visualization.visualizationSources.forEach(vs => {
    if (vs.friendly_type === ModelType.Form) {
      loadForm(vs.source_obj_as_json_for_builder);
    } else if (vs.friendly_type === ModelType.ObjectModel) {
      loadObjectModel(vs.source_obj_as_json_for_builder);
    }
  });
}